import React, { useEffect, useState } from "react";
import axios from "axios";
import { API } from "./api";
import "./SubServiceImageUpload.css";

export default function SubServiceImageUpload() {
  const [subServices, setSubServices] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState({});
  const [selectedCategory, setSelectedCategory] = useState("All");

  // Fetch sub-services list on load
  useEffect(() => {
    axios
      .get(API.GET_SUB_SERVICES)
      .then((res) => setSubServices(res.data))
      .catch((err) => console.error("Error fetching services:", err));
  }, []);

  // Handle file selection
  const handleFileChange = (id, file) => {
    setSelectedFiles({ ...selectedFiles, [id]: file });
  };

  // Handle file upload
  const handleUpload = async (id) => {
    if (!selectedFiles[id]) {
      alert("Please select a file first.");
      return;
    }

    const formData = new FormData();
    formData.append("id", id);
    formData.append("image", selectedFiles[id]);

    try {
      const res = await axios.post(API.UPLOAD_IMAGE, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (res.data.status === "success") {
        alert("Image uploaded successfully!");
        setSubServices((prev) =>
          prev.map((s) =>
            s.id === id ? { ...s, image_url: res.data.image_url } : s
          )
        );
      } else {
        alert(res.data.message || "Upload failed");
      }
    } catch (err) {
      console.error(err);
      alert("Upload failed");
    }
  };

  // Extract unique categories (main_service)
  const categories = ["All", ...new Set(subServices.map((s) => s.main_service))];

  // Filter services based on selected category
  const filteredServices =
    selectedCategory === "All"
      ? subServices
      : subServices.filter((s) => s.main_service === selectedCategory);

  return (
    <div className="container">
      <h2 className="title">Sub-Services Image Upload</h2>

      {/* Dropdown filter */}
      <div className="dropdown-container">
        <label htmlFor="category">Filter by Service: </label>
        <select
          id="category"
          value={selectedCategory}
          onChange={(e) => setSelectedCategory(e.target.value)}
        >
          {categories.map((cat) => (
            <option key={cat} value={cat}>
              {cat}
            </option>
          ))}
        </select>
      </div>

      <div className="grid">
        {filteredServices.map((service) => (
          <div key={service.id} className="card">
            <h4 className="card-title">{service.sub_service_title}</h4>
            <p className="card-desc">{service.sub_service_description}</p>

            {service.image_url ? (
              <img
                src={service.image_url}
                alt="Preview"
                className="preview"
              />
            ) : (
              <div className="no-image">No image uploaded</div>
            )}

            <input
              type="file"
              accept="image/*"
              onChange={(e) =>
                handleFileChange(service.id, e.target.files[0])
              }
              className="file-input"
            />
            <button
              onClick={() => handleUpload(service.id)}
              className="upload-btn"
            >
              Upload
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
